<template>
  <div>
    <b-modal
      v-model="showModal"
      size="md"
      :title="title"
      modal-class="modal-filter"
      hide-header-close
      scrollable
    >
      <div class="card-body p-2">
        <FormulateForm ref="formRef" v-model="formValues">
          <slot
            name="content"
            :formValues="formValues"
            :updateFormValues="updateFormValues"
            :fullObjects="fullObjects"
            :updateFullObjects="updateFullObjects"
          />
        </FormulateForm>
      </div>
      <template #modal-header>
        <span class="__title"> {{ title }} </span>
      </template>
      <template #modal-footer>
        <b-row class="modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="modal__filter-footer-btn">
            <McButton
              variant="secondary"
              class="me-2"
              :text="$t('global.action.cancel')"
              @click="showModal = false"
            />
            <McButton
              variant="primary"
              :text="$t('global.action.apply')"
              :disabled="$refs.formRef?.hasErrors"
              @click="handleAccept"
            />
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'
import { mapGetters } from 'vuex'

export default {
  components: {
    McButton,
  },
  props: {
    title: {
      type: String,
      default: 'Filter',
    },
    activeFilters: {
      type: Object,
      required: true,
    },
    parseFilterDataMappings: {
      type: Object,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      require: true,
    },
    reportValue: {
      type: String,
      default: '',
    },
  },
  emits: ['submit'],
  data() {
    return {
      formValues: {},
      oldFormValues: {},

      fullObjects: {},
      oldFullObjects: {},
    }
  },
  computed: {
    ...mapGetters({ hasAccess: 'identity/hasAccess', isParent: 'identity/isParent' }),
    showModal: {
      set(newVal) {
        this.$emit('update:value', newVal)
      },
      get() {
        return this.value
      },
    },
  },
  watch: {
    showModal(newValue) {
      if (!newValue) return

      Object.keys(this.parseFilterDataMappings).forEach((key) => {
        if (!Array.isArray(this.parseFilterDataMappings[key])) {
          this.$set(this.formValues, key, this.activeFilters[this.parseFilterDataMappings[key]])
          return
        }

        const arr = []
        this.parseFilterDataMappings[key].forEach((keyMapping) => {
          arr.push(this.activeFilters[keyMapping])
        })
        this.$set(this.formValues, key, arr)
      })

      this.fullObjects = cloneDeep(this.oldFullObjects)
    },
  },
  methods: {
    updateFormValues({ key, value }) {
      this.$set(this.formValues, key, value)
    },
    updateFullObjects({ key, value }) {
      this.$set(this.fullObjects, key, value)
    },
    parseData() {
      const newValueKeys = Object.keys(this.formValues)
      const filters = []
      newValueKeys.forEach((key) => {
        // mapping the filter data to be emit
        if (!Array.isArray(this.parseFilterDataMappings[key])) {
          filters.push({ key: this.parseFilterDataMappings[key], values: this.formValues[key] })
          return
        }

        this.parseFilterDataMappings[key].forEach((keyMapping, index) => {
          filters.push({ key: keyMapping, values: this.formValues[key][index] })
        })
      })
      return filters
    },
    handleAccept() {
      if (!isEqual(this.formValues, this.oldFormValues)) {
        this.$emit('submit', this.parseData())
        this.oldFormValues = cloneDeep(this.formValues)
        this.oldFullObjects = cloneDeep(this.fullObjects)
      }

      if (this.reportValue === 'costManagement') {
        this.$store.commit('report/updateExpensesFilter', this.formValues)
        this.$router.push({ name: 'Report Expenses' })
        return
      }

      if (this.reportValue === 'fleetUtilization') {
        if (!this.formValues.created_on) {
          this.$mcToast.error(
            `${this.$t('report.object.reportPeriod')} ${this.$t('report.filters.required')}`
          )
          return
        } else if (
          this.isParent() &&
          this.hasAccess(['a10e-report-child-monitoring:read']) &&
          this.formValues.company_id.length === 0
        ) {
          this.$mcToast.error(
            `${this.$t('setting.list.managementAsset.subdomain.domain')} ${this.$t(
              'report.filters.required'
            )}`
          )
          return
        } else {
          this.$store.commit('report/updateFleetUtilizationFilter', this.formValues)
          this.$store.commit('report/updateFleetUtilizationFullObjects', this.fullObjects)

          this.$router.push({ name: 'Report Fleet Utilization' })
          return
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.modal-filter) {
  .modal-dialog {
    border-radius: 0px;
    overflow: hidden;
    height: 100%;
    margin: 0;
    margin-left: auto;
  }

  .modal-content {
    height: 100%;
  }

  .modal-content,
  .modal-header,
  .modal-footer {
    border-radius: 0;

    .modal__filter-footer-btn {
      display: flex;
    }
  }

  .modal-header {
    color: $white;
    justify-content: space-between;

    .__reset {
      font-size: 13px;
      text-align: right;
      cursor: pointer;
    }
  }
}
</style>
